import { FOOTER, HEADER } from '@opengov/stories-shared/constants/storyContents';

export const TYPE_FRAGMENT = 'fragment';

// Block constants
export const SECTION = 'section';
export const NAV = 'nav';
export const TABLE = 'table';
export const TABLE_ROW = 'table-row';
export const TABLE_CELL = 'table-cell';
export const TABLE_HEADER = 'table-header';
export const TABLE_BODY = 'table-body';
export const DIV = 'div';
export const IMG = 'img';
export const VIDEO = 'video';
export const IFRAME = 'iframe';
export const HEADING_ONE = 'heading-one';
export const HEADING_TWO = 'heading-two';
export const HEADING_THREE = 'heading-three';
export const BLOCKQUOTE = 'block-quote';
export const PARAGRAPH = 'paragraph';
export const BREAK = 'break';
export const UNORDERED_LIST = 'unordered-list';
export const ORDERED_LIST = 'ordered-list';
export const LIST_ITEM = 'list-item';
export const LIST_ITEM_CHILD = 'list-item-child';
export const SPAN = 'span';
export const SCRIPT = 'script';

export const EDITABLE_CONTENT_CLASS = 'editable editable-content';

// Inline constants
export const LINK = 'link';

// Mark constants
export const ITALIC = 'italic';
export const BOLD = 'bold';
export const UNDERLINED = 'underlined';
export const LEFT = 'left';
export const CENTER = 'center';
export const RIGHT = 'right';
export const JUSTIFY = 'justify';
export const COLOR = 'color';

//File Size in bytes
export const MAX_IMAGE_UPLOAD_SIZE = 10; //10 MB
export const MAX_VIDEO_UPLOAD_SIZE = 40; //40 MB

// Dictionaries for tags
export const BLOCK_TAGS = {
  header: HEADER,
  footer: FOOTER,
  section: SECTION,
  nav: NAV,
  div: DIV,
  img: IMG,
  video: VIDEO,
  iframe: IFRAME,
  h1: HEADING_ONE,
  h2: HEADING_TWO,
  h3: HEADING_THREE,
  blockquote: BLOCKQUOTE,
  p: PARAGRAPH,
  br: BREAK,
  ul: UNORDERED_LIST,
  ol: ORDERED_LIST,
  li: LIST_ITEM,
  script: SCRIPT,
  a: LINK,
  table: TABLE,
  tr: TABLE_ROW,
  th: TABLE_HEADER,
  td: TABLE_CELL,
  tbody: TABLE_BODY
};

export const INLINE_TAGS = {
  a: LINK
};

export const MARK_TAGS = {
  em: ITALIC,
  strong: BOLD,
  u: UNDERLINED,
  span: COLOR
};

export const DETAIL_TABLE_MAX_COLUMN_LIMIT = 15;
export const REPORT_TABLE_MAX_LIMIT = 15;

export enum EMBED_REQUEST_TYPE {
  SummaryTable = 'SUMMARY_TABLE_EMBED_REQUEST',
  DetailTable = 'DETAIL_TABLE_EMBED_REQUEST'
}

export enum EMBED_SYNC_SETTING {
  LIVE = 'live',
  SNAPSHOT = 'snapshot',
  REFRESH_ON_UPDATE = 'refresh-on-update'
}

export const embedV2Host = 'embed_crud_service';
export const embedV3Host = 'embed_service';
